import { render } from "./Skeleton.vue?vue&type=template&id=c592e2e6&scoped=true&ts=true"
import script from "./Skeleton.vue?vue&type=script&lang=ts"
export * from "./Skeleton.vue?vue&type=script&lang=ts"

import "./Skeleton.vue?vue&type=style&index=0&id=c592e2e6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c592e2e6"]])

export default __exports__